import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  chargeTypeContainer: {
    padding: '7.58px 15px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    opacity: 0.5,
    display: 'inline-block',
  },
}));
